import TakeABreak from './TakeABreak'

export { TAKE_A_BREAK_ROUTE } from './constants'
export const TakeABreakPage = TakeABreak
